<template>
  <div class="table-container">
    <button
      v-if="canSellItems"
      class="button sell-items-btn"
      @click="$emit('sell-items')"
    >
      SELL ITEMS
    </button>

    <button v-else class="button sell-items-btn" @click="$emit('coming-soon')">
      SELL ITEMS
    </button>
    <table>
      <thead>
        <tr>
          <td>ID</td>
          <td>DATE</td>
          <td>ITEMS</td>
          <td>TOTAL</td>
          <td>STATUS</td>
          <td>ACTION</td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!sellRequestHistory || !sellRequestHistory.length">
          <td colspan="6" class="no-sell-requests">No sell requests yet.</td>
        </tr>
        <tr v-for="(req, i) in sellRequestHistory" :key="i">
          <td>#{{ req.id }}</td>
          <td>{{ formatDate(req.created_at) }}</td>
          <td>
            <div
              class="sell-request-item"
              v-for="(item, j) in req.items"
              :key="j"
            >
              {{ item.short_name }} x{{ item.quantity }}
            </div>
          </td>
          <td>
            <div class="amount-inline">
              <b class="price">{{ req.total_amount }}</b>
              <img
                src="../../images/coin.svg"
                class="currency-icon"
                alt="coin"
              />
            </div>
            <div
              class="counter-offer-amount"
              v-if="
                req.counter_offer_amount !== null &&
                req.status === 'CounterOffer'
              "
            >
              <span class="counter-offer-label">Offer:</span>
              <span class="amount-inline">
                <b class="price">{{ req.counter_offer_amount }}</b>
                <img
                  src="../../images/coin.svg"
                  class="currency-icon"
                  alt="coin"
                />
              </span>
            </div>
          </td>
          <td :class="'status ' + req.status.toLowerCase()">
            <span>{{ formatStatus(req.status) }}</span>
          </td>
          <td class="action-cell">
            <button
              v-if="req.status === 'CounterOffer'"
              class="button action-btn view-offer-btn"
              @click="$emit('view-offer', req)"
            >
              VIEW OFFER
            </button>
            <span v-else class="no-action">-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination" v-if="sellRequestMeta.last_page > 1">
      <button
        class="pagination-btn"
        :disabled="sellRequestMeta.current_page <= 1"
        @click="$emit('change-page', sellRequestMeta.current_page - 1)"
      >
        &laquo;
      </button>
      <button
        class="pagination-btn"
        v-for="p in sellRequestMeta.last_page"
        :key="p"
        :class="{ active: p === sellRequestMeta.current_page }"
        @click="$emit('change-page', p)"
      >
        {{ p }}
      </button>
      <button
        class="pagination-btn"
        :disabled="sellRequestMeta.current_page >= sellRequestMeta.last_page"
        @click="$emit('change-page', sellRequestMeta.current_page + 1)"
      >
        &raquo;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileSellRequestsTab',
  props: {
    sellRequestHistory: {
      type: Array,
      default: () => [],
    },
    sellRequestMeta: {
      type: Object,
      default: () => ({ current_page: 1, last_page: 1, total: 0 }),
    },
    formatDate: {
      type: Function,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    canSellItems() {
      const payoutsEnabled =
        this.settings && this.settings.payout_enabled === true

      const payoutMethods = this.settings && this.settings.payout_methods

      const methods = Array.isArray(payoutMethods)
        ? payoutMethods
        : payoutMethods && typeof payoutMethods === 'object'
          ? Object.values(payoutMethods)
          : []

      const hasActivePayoutMethod = methods.some(
        (method) => method === 'card' || method === 'sepa',
      )

      return payoutsEnabled && hasActivePayoutMethod
    },
  },
  methods: {
    formatStatus(status) {
      const map = {
        CounterOffer: 'Counter Offer',
        UserDeclined: 'Declined',
      }
      return map[status] || status
    },
  },
}
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  overflow-x: auto !important;
}
.sell-items-btn {
  margin-bottom: 20px;
}

.sell-request-item {
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
}

td.no-sell-requests {
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  padding: 40px 0 !important;
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 24px;
  padding-bottom: 16px;
}

.pagination-btn {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &.active {
    background: #0d4e9e;
    border-color: #0d4e9e;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.counter-offer-amount {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.counter-offer-label {
  font-size: 12px;
  color: #ff8400;
  font-weight: 500;
}

.counter-offer-amount .price {
  color: #ff8400;
  font-size: 13px;
}

.action-cell {
  white-space: nowrap;
}

.no-action {
  color: rgba(255, 255, 255, 0.3);
}

.action-btn {
  font-size: 12px;
  padding: 6px 14px;
  min-width: auto;
}

.view-offer-btn {
  min-width: auto;
}

.amount-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
}

.amount-inline .currency-icon {
  width: 16px;
  height: 16px;
  position: relative;
  top: 1px;
}
</style>
